import { ExpandMore } from '@mui/icons-material';
import { Grid, Popover } from '@mui/material';
import { useState } from 'react';
import { WsButton } from 'wisestep-base';

interface ISmartFilterProps {
  filterName: string;
  children: React.ReactNode;
  onClick: () => void;
  onClickFilter?: () => void;
  onClear: () => void;
  filterValue: boolean | string | number | readonly string[] | null | undefined;
}

const SmartFilter = ({
  filterName,
  children,
  onClick,
  onClickFilter = () => {},
  onClear,
  filterValue,
}: ISmartFilterProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);

  const id = open ? 'simple-popover' : undefined;
  const handleClick = (event?: React.MouseEvent<HTMLDivElement>) => {
    onClickFilter();
    event && setAnchorEl(event.currentTarget);
  };
  const clearAllFields = () => {
    setAnchorEl(null);
    onClear();
  };

  const isFilterActive = filterValue && filterValue !== 'All' && filterValue !== 'None';

  return (
    <>
      <WsButton
        variant={!isFilterActive ? 'black' : 'text'}
        size="medium"
        endIcon={<ExpandMore />}
        onClick={(event) => handleClick(event as React.MouseEvent<HTMLDivElement>)}
      >
        {filterName}
      </WsButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            width: '30%',
            maxWidth: '100%',
          },
        }}
      >
        <Grid item xs={12} container sx={{ p: 2, gap: 2, alignItems: 'center' }}>
          <Grid item xs={8}>
            {children}
          </Grid>
          <WsButton
            variant="contained"
            size="small"
            onClick={() => {
              onClick();
              setAnchorEl(null);
            }}
          >
            Apply
          </WsButton>
          <WsButton
            type="reset"
            variant="contained"
            size="small"
            onClick={() => {
              clearAllFields();
              setAnchorEl(null);
            }}
          >
            Clear
          </WsButton>
        </Grid>
      </Popover>
    </>
  );
};

export default SmartFilter;
